import { useState, useLayoutEffect, useCallback } from "react";

export const useContainerDimensions = (myRef: any) => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })

  const getDimensions = useCallback(() => { return {
    width: myRef.current.clientWidth,
    height: myRef.current.clientHeight,
  }}, [myRef]);

  useLayoutEffect(() => {
    const handleResize = () => {
      setDimensions(getDimensions());
    }

    if (myRef.current) {
      handleResize();
    }

    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [getDimensions, myRef])

  return dimensions;
};